module.exports = __webpack_public_path__ + "img/trends-active.2216434a.svg";